import Layout from "../components/Layout";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import QuarterNames from "../components/QuarterNames";


const PMSCycleReport = () => {
    const [isLoading, setIsLoading] = useState(false)
    const { user } = useSelector((state) => state["auth"]);
    const [pmsCycleData, setPmsCycleReport] = useState([]);

    useEffect(() => {
        GetPMSFiscalYears();
    }, [])

    const GetPMSFiscalYears = () => {
        setIsLoading(true);

        axios.post(BASE_URL + "/api/dashboard/GetPMSCycleNames")
            .then(response => {
                setPmsCycleReport(response.data)
                setIsLoading(false);
            })
            .catch(console.error)
    }

    const DownloadReportInExcel = () => {
        var e = document.getElementById("ddlPmsCycle");
        var _selectedValue = e.value==="-1"?2023:e.value;
        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PMSUtilityInfoReport?SearchStr="+btoa("PmsCycle=" + _selectedValue));
    }

    return (
        <Layout>
            <div className="card  text-dark bg-light mb-3">
                <div class="card-header">
                    <div className="row">
                        <div className="col-3">
                            <h6><i class="bi bi-table"></i> PMS Cycle Report</h6>
                        </div>
                        <div className="col-3"></div>
                        <div className="col-4">

                        </div>
                        <div className="col-2">                           
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div className="row">
                        <div class="col-sm-3">
                        <select id="ddlPmsCycle" name="ddlPmsCycle" className="form-select form-select-sm"
                            aria-label=".form-select-sm example">
                            <option value={-1}>{"-- Select PMS Cycle --"}</option>
                            {pmsCycleData.map((value, index) => <option key={index}
                                value={value.pmsFiscalYear}>{value.pmsFiscalYear}</option>)}
                        </select>
                        </div>
                        <div class="col-sm-2">
                        <button className="btn btn-primary btn-sm float-end" onClick={DownloadReportInExcel}><i class="bi bi-chevron-double-down"></i> Download</button>                        
                        </div>
                        <div class="col-sm-7"></div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default PMSCycleReport